import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
} from '@angular/core';
import { NugetType } from '@models';
import {
    GRID_SERVICE,
    STATE_HANDLER,
    urlStateHandler,
} from '@pages/generics/grid';
import { PackageService } from '@services/package.service';

import { NugetGridComponent } from './grids';

@Component({
    templateUrl: './grids/nuget/nuget.grid.html',
    providers: [{
        provide: GRID_SERVICE,
        useClass: PackageService,
    },
    {
        provide: STATE_HANDLER,
        useValue: urlStateHandler,
    }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackagesPageComponent
    extends NugetGridComponent
    implements OnInit {

    public type = NugetType.Packages;

    ngOnInit() {
        this.createPermission = 'Packages.Create';
    }
}
